import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BookingListService } from '../Services/bookingList.service';
import { NgModule } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BookingListNew, BookingListProperties, BookingRights } from '../Models/BookingListProperties';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { formatDate } from '@angular/common';
import { DxDataGridComponent } from 'devextreme-angular';
import { Observable, of, Subject } from 'rxjs';
import { Agencies_BranchesProperties, AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { DatePipe } from '@angular/common'
import { OfflineToOnlineProperties, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
//import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bookingList',
  templateUrl: './bookingList.component.html',
  styleUrls: ['./bookingList.component.css']
})
//@NgModule({ imports: [FormsModule, NgbModal] })

export class BookingListComponent {
  constructor(private bookingListService: BookingListService, private http: HttpClient, private router: Router, private ticketIssuanceService: TicketIssuanceService) { };
  closeResult = '';
  //modalOptions: NgbModalOptions;
  bookingList: BookingListProperties[] = [];
  collapsed = false;
  tktPnrRight = new TicketPnrRights();
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  agencyList: Agencies_BranchesProperties[] = [];
  userId = 0;
  isExpanded = false;
  selectedValue: string;
  rightsObj = new BookingRights();
  bookingNew = new BookingListNew();
  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit() {
   
    if (localStorage.getItem("AgencyId") != "" || localStorage.getItem("AgencyId") != null) {
      this.bookingNew.agencyId = (localStorage.getItem("AgencyId"));
    } //Adeel
    this.LoadAgencyList();
    this.getBookingList();
    this.loadrights();
  }

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  getBookingRights() {
    this.bookingListService.GetBookingRights(localStorage.getItem("agencyId"), localStorage.getItem("userId")).subscribe((data) => {
      this.rightsObj = data;

    });
  }
  LoadAgencyList() {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.bookingListService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyList = data;
            this.agencyCodeList$ = of(data);
          });
        }
      }

    }
    catch (e) {
    }
  }


  AgencyCodeChange() {
    try {
      if (this.bookingNew.fromBooking != null && this.bookingNew.fromBooking != '' && this.bookingNew.toBooking != null && this.bookingNew.toBooking != '') {
        if (this.bookingNew.agencyId == null || this.bookingNew.agencyId == '') {
          this.bookingNew.agencyId = localStorage.getItem("AgencyId")
          
        }
       
      }
      else {
        if (this.bookingNew.agencyId == null || this.bookingNew.agencyId == '') {
          this.bookingNew.agencyId = localStorage.getItem("AgencyId")

        }

        
    
      }
      this.bookingNew.userId = Number(localStorage.getItem("UserId"));

      this.bookingListService.getBookingList(this.bookingNew).subscribe((data) => {
        this.bookingList = data;
        this.bookingNew.agencyId = null;
          for (let i = 0; i < this.bookingList.length; i++) {
            this.bookingList[i].bookingDate = this.bookingList[i].bookingDate.split('T')[0];
            this.bookingList[i].travelDate = this.bookingList[i].travelDate.split('T')[0];
            this.bookingList[i].bookingDate = this.bookingList[i].bookingDate.split('T')[0];
          };
        });
      }
    
    catch (e) { }
  }

  getBookingList() {
    try {
      
      this.bookingNew.userId = Number(localStorage.getItem("UserId"));
 
      this.bookingListService.getBookingList(this.bookingNew).subscribe((data) => {
        this.bookingNew.agencyId = null;
        this.bookingList = data;
        for (let i = 0; i < this.bookingList.length; i++) {
          this.bookingList[i].bookingDate = this.bookingList[i].bookingDate.split('T')[0];
          //new work
          let DateFormat = this.bookingList[i].bookingDate;

          let dateDateLong: Date = new Date(DateFormat);
          let datePipe: DatePipe = new DatePipe('en-UK');
          this.bookingList[i].bookingDate = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));
          this.bookingList[i].travelDate = this.bookingList[i].travelDate.split('T')[0];
          let DatetravelFormat = this.bookingList[i].travelDate;
          let datetravelDateLong: Date = new Date(DatetravelFormat);
          let datetravelPipe: DatePipe = new DatePipe('en-UK');

          this.bookingList[i].travelDate = (datetravelPipe.transform(datetravelDateLong, 'dd/MM/yyyy'));
          //new work
          /*  this.bookingList[i].bookingDate = this.bookingList[i].bookingDate.split('T')[0];*/
        };

      });

      //}
    }
    catch (e) {
      //console.log(e);
    }
  }

  loadrights() {
    ////////////////////////////////////////
    this.ticketIssuanceService.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data2) => {
      this.tktPnrRight = data2;
    })
  }

  //open(content) {
  //  this.modalService.open(content,
  //    { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
  //      this.closeResult = `Closed with: ${result}`;
  //    }, (reason) => {
  //      this.closeResult =
  //        `Dismissed ${this.getDismissReason(reason)}`;
  //    });
  //}

  //private getDismissReason(reason: any): string {
  //  if (reason === ModalDismissReasons.ESC) {
  //    return 'by pressing ESC';
  //  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //    return 'by clicking on a backdrop';
  //  } else {
  //    return `with: ${reason}`;
  //  }
  //}


  //getFareRules() {

  //}
  offlinetoOnline = new OfflineToOnlineProperties();
  Edit_Click(getdata) {
    try {
      //offlinetoOnline = new OfflineToOnlineProperties();
      // replace this condtion
      if (getdata.bookingStatus == "Requested") {
        if (getdata.groupTicketId > 0) {
          localStorage.setItem('bookingID', getdata.bookingID);
          localStorage.setItem("fromroutePageNoright", "BookingPage");
          this.router.navigateByUrl('/ticket-issuance');
        }
        else {
          this.bookingListService.getBookingrequestId(getdata.bookingID).subscribe((data) => {
            if (data.requestTypeName == "Online Ticket Request") {
              if (this.tktPnrRight.issueTicket) {
                localStorage.setItem("bookingID", getdata.bookingID);
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.TicketIssueReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                localStorage.setItem("OffilineRequest", "True");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));

                this.router.navigateByUrl('/ticket-issuance');
              }
              else {
                localStorage.setItem("bookingID", getdata.bookingID);
                localStorage.setItem("OffilineRequest", "False");
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.TicketIssueReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));

                this.router.navigateByUrl('/ticket-issuance');
              }
            }
            else if (data.requestTypeName == "Online Void Request") {
              if (this.tktPnrRight.voidTicket) {
                localStorage.setItem("bookingID", getdata.bookingID);
                localStorage.setItem("OffilineRequest", "True");
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.VoidReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");

                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
                this.router.navigateByUrl('/ticket-issuance');
              }
              else {
                localStorage.setItem("bookingID", getdata.bookingID);
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.VoidReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                localStorage.setItem("OffilineRequest", "False");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
                this.router.navigateByUrl('/ticket-issuance');
              }
            }
            else if (data.requestTypeName == "Online PNR Cancel Request") {
              if (this.tktPnrRight.cancelPnr) {
                localStorage.setItem("bookingID", getdata.bookingID);
                localStorage.setItem("OffilineRequest", "True");
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.PNRReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
                this.router.navigateByUrl('/ticket-issuance');
              }
              else {
                localStorage.setItem("bookingID", getdata.bookingID);
                localStorage.setItem("OffilineRequest", "False");
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.PNRReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
                this.router.navigateByUrl('/ticket-issuance');
              }
            }
            else if (data.requestTypeName == "Online Refund Request") {
              if (this.tktPnrRight.refund) {
                localStorage.setItem("bookingID", getdata.bookingID);
                localStorage.setItem("OffilineRequest", "True");
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.RefundReqFromOffline = true;
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
                this.router.navigateByUrl('/ticket-issuance');
              }
              else {
                localStorage.setItem("bookingID", getdata.bookingID);
                this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
                this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
                this.offlinetoOnline.RefundReqFromOffline = true;
                localStorage.setItem("OffilineRequest", "False");
                localStorage.setItem("fromroutePageNoright", "BookingPage");
                this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
                localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
                this.router.navigateByUrl('/ticket-issuance');

              }
            }
          })
        }

      }
      else {
        localStorage.setItem('bookingID', getdata.bookingID);
        localStorage.setItem("fromroutePageNoright", "BookingPage");
        this.router.navigateByUrl('/ticket-issuance');
      }

    }
    catch (e) { }
  }
}
